import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import ArticleCard from '@/components/base/ArticleCard';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useState } from 'react';

const featuredArticles = articles.filter((a) => a.featured);
const latestArticles = articles.slice(0, 6);
const highlightedCategories = categories.slice(0, 4);

export default function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % featuredArticles.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + featuredArticles.length) % featuredArticles.length);

  const heroImages = [
    'https://readdy.ai/api/search-image?query=Elegant%20sweet%20Lolita%20fashion%20model%20in%20pink%20lace%20dress%20with%20white%20stockings%20standing%20in%20a%20dreamy%20rose%20garden%2C%20soft%20pastel%20background%20with%20cherry%20blossoms%2C%20romantic%20feminine%20editorial%20photography%20with%20gentle%20golden%20hour%20lighting%2C%20ethereal%20atmosphere&width=1800&height=900&seq=hero-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Classic%20Lolita%20fashion%20group%20gathering%20at%20elegant%20tea%20party%2C%20beautiful%20Victorian%20style%20dresses%20in%20cream%20and%20burgundy%2C%20vintage%20table%20setting%20with%20fine%20china%2C%20warm%20chandelier%20lighting%2C%20sophisticated%20romantic%20atmosphere%2C%20editorial%20photography&width=1800&height=900&seq=hero-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Gothic%20Lolita%20fashion%20model%20in%20black%20lace%20dress%20with%20elegant%20parasol%2C%20mysterious%20moonlit%20garden%20setting%2C%20dark%20romantic%20roses%20and%20ivy%2C%20dramatic%20soft%20lighting%2C%20editorial%20fashion%20photography%20with%20enchanting%20atmosphere&width=1800&height=900&seq=hero-3&orientation=landscape',
  ];

  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <div className="absolute inset-0 transition-all duration-700">
            <img
              src={heroImages[currentSlide]}
              alt="白丝萝莉 - 洛丽塔时尚"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>

          <button
            onClick={prevSlide}
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/30 backdrop-blur-sm text-background-50 hover:bg-background-50/50 transition-all duration-200 cursor-pointer z-10"
            aria-label="上一张"
          >
            <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/30 backdrop-blur-sm text-background-50 hover:bg-background-50/50 transition-all duration-200 cursor-pointer z-10"
            aria-label="下一张"
          >
            <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
          </button>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-3 md:mb-4 leading-tight">
              <a href="/">白丝萝莉</a>
            </h1>
            <p className="text-sm md:text-lg text-background-50/90 max-w-xl mb-6 md:mb-8 leading-relaxed">
              探索洛丽塔时尚的无限魅力，分享精致甜美的生活方式。从甜美到古典，从穿搭到品牌，发现属于你的洛丽塔美学。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/chuanda-zhinan"
                className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                开始探索
              </Link>
              <Link
                to="/about"
                className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
            {heroImages.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentSlide(i)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  i === currentSlide ? 'bg-background-50 w-6' : 'bg-background-50/50'
                }`}
                aria-label={`第${i + 1}张`}
              />
            ))}
          </div>
        </section>

        {/* Featured Categories */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
                探索洛丽塔风格
              </h2>
              <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                从甜美到古典，从哥特到中华风——每一种洛丽塔风格都有其独特的魅力
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {highlightedCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group block bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 md:mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-1.5">
                    {cat.name}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {cat.description}
                  </p>
                  <p className="text-xs text-foreground-500 mt-3">
                    {cat.articleCount} 篇文章
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-8 md:mb-10">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-1">
                  精选文章
                </h2>
                <p className="text-sm text-foreground-600">编辑精选的优质洛丽塔内容</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="flex items-center justify-between mb-8 md:mb-10">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-1">
                  最新资讯
                </h2>
                <p className="text-sm text-foreground-600">紧跟洛丽塔时尚的最新动态</p>
              </div>
              <Link
                to="/category/chuanda-zhinan"
                className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative py-16 md:py-20 px-4 md:px-6 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Beautiful%20Lolita%20fashion%20community%20gathering%20with%20diverse%20dress%20styles%2C%20warm%20friendly%20atmosphere%2C%20soft%20cream%20and%20blush%20pink%20background%20with%20delicate%20floral%20elements%2C%20inclusive%20welcoming%20vibe%2C%20gentle%20editorial%20photography%20with%20natural%20light&width=1800&height=600&seq=cta-section&orientation=landscape"
              className="w-full h-full object-cover"
              alt="加入洛丽塔社区"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-primary-900/60 via-primary-800/50 to-primary-900/60"></div>
          <div className="relative z-10 max-w-xl mx-auto text-center">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              加入白丝萝莉社区
            </h2>
            <p className="text-sm md:text-base text-background-50/85 mb-6 leading-relaxed">
              与50万+洛丽塔爱好者一起，探索时尚、分享穿搭、交流心得。无论你是新手还是资深爱好者，这里都有属于你的位置。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}